import processResponseResults from './processResponseResults';
import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import store from '../../store/store';
import { getSuggestionsService } from '../people/getSuggestionsService';
import getTransactionIdFromResponse from '../../utils/getTransactionIdFromResponse';
import { now } from 'owa-datetime';
import { populateFeedbackStateNetwork } from '../../utils/populateFeedbackState';
import processSubstrateSuggestionsResponse from 'owa-recipient-common/lib/actions/processSubstrateSuggestionsResponse';
import addToCache from 'owa-recipient-cache/lib/actions/addToCache';
import FindControlViewState from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import addTransactionComplete from 'owa-recipient-common/lib/utils/addTransactionComplete';
import addTransactionFailed from 'owa-recipient-common/lib/utils/addTransactionFailed';
import { SubstrateSearchSuggestionsResponse } from 'owa-search-service';
import shouldUse3SPeopleSuggestions from 'owa-substrate-people-suggestions/lib/utils/shouldUse3SPeopleSuggestions';
import FindPeopleResponseMessage from 'owa-service/lib/contract/FindPeopleResponseMessage';
import PersonaType from 'owa-service/lib/contract/PersonaType';
import { action } from 'satcheljs/lib/legacy';

const MAX_ENTRIES_TYPEDOWN = 5;

export default action('backfillCache')(async function backfillCache(
    recipientWell: FindControlViewState | RecipientWellWithFindControlViewState,
    queryString: string
): Promise<void> {
    store.pendingFindPeopleRequests++;
    let suggestionService = getSuggestionsService();

    let transactionStartTime = now();

    // Record the beginning of the live call
    // in case the live call hangs and the user submits feedback before it returns
    populateFeedbackStateNetwork(recipientWell, transactionStartTime, null);
    return suggestionService(queryString, false /*searchDirectory*/).then(serverResults => {
        const transactionId = getTransactionIdFromResponse(serverResults);
        try {
            const resultSet = getPersonaResults(serverResults);

            // Backfill the cache with server results
            addToCache(resultSet);
            store.pendingFindPeopleRequests--;

            // If there are server results, use the server results
            if (!isServerResultEmpty(serverResults) && recipientWell.queryString == queryString) {
                const hasCacheResults = recipientWell.findResultSet.length > 0;
                populateFeedbackStateNetwork(recipientWell, transactionStartTime, serverResults);

                // Process the response results to update the UI. If the UI already has cache results for this query, this will append the server results to the end of the list.
                // Otherwise it will clear out the existing find result set (from a previous query) and replace with the live results
                processResponseResults(
                    recipientWell.findResultSet,
                    serverResults,
                    hasCacheResults,
                    MAX_ENTRIES_TYPEDOWN
                );
                addTransactionComplete(recipientWell, transactionStartTime, transactionId);
            }
        } catch {
            addTransactionFailed(recipientWell, transactionStartTime, transactionId);
        }
    });
});

export function getPersonaResults(
    serverResult: FindPeopleResponseMessage | SubstrateSearchSuggestionsResponse
): PersonaType[] {
    if (shouldUse3SPeopleSuggestions()) {
        let personas = [];
        processSubstrateSuggestionsResponse(
            personas,
            serverResult as SubstrateSearchSuggestionsResponse,
            false
        );
        return personas;
    } else {
        return (serverResult as FindPeopleResponseMessage).ResultSet;
    }
}

function isServerResultEmpty(
    serverResult: FindPeopleResponseMessage | SubstrateSearchSuggestionsResponse
): boolean {
    if (shouldUse3SPeopleSuggestions()) {
        const result = serverResult as SubstrateSearchSuggestionsResponse;
        return !result || !result.Groups;
    } else {
        const result = serverResult as FindPeopleResponseMessage;
        return result.ResponseClass != 'Success' || result.ResultSet.length == 0;
    }
}
